import React from 'react';
import { useGet } from "seed/api";
import { Loading } from "seed/helpers";
import PortalStarted from "components/tmisc/portal/started/Started";
import PortalRequested from "components/tmisc/portal/requested/Requested";
import PortalProposed from 'components/tmisc/portal/proposed/Proposed';
import PortalAdjusting from 'components/tmisc/portal/adjusting/Adjusting';
import PortalTemplateRequested from 'components/tmisc/portal/template_requested/TemplateRequested';
import PortalDeveloping from 'components/tmisc/portal/developing/Developing';
import PrototypeEditor from "components/brief/reviewer/prototype/Prototype";
import { useAuth } from "components/util/helpers/providers/AuthProvider";

const Portal = ({ flow }) => {

  const user = useAuth();
  const isDeveloper = user?.isDeveloper;

  const reqRevision = useGet("/flows/get_last_revision", { flow_id: flow.id });

  if (reqRevision.loading) return <div className="h-100"><Loading /></div>;
  if (reqRevision.error) return "";

  const buildStatus = reqRevision.data?.build_status || "NONE";

  if (buildStatus == "STARTED")
    return <PortalStarted flow={flow} />;

  if (buildStatus == "REQUESTED")
    return <PortalRequested
      flow={flow}
    />;

  if (buildStatus == "PROPOSAL_PROPOSED")
    return <PortalProposed
      flow={flow}
    />;

  if (buildStatus == "PROTOTYPE_PROPOSED")
    return <PrototypeEditor
      flow={flow}
      isDeveloper={isDeveloper}
    />;

  if (buildStatus == "PROPOSAL_ADJUSTING" || buildStatus == "PROTOTYPE_ADJUSTING")
    return <PortalAdjusting
      flow={flow}
      buildStatus={buildStatus}
    />;

  if (buildStatus == "DEVELOPING")
    return <PortalDeveloping
      flow={flow}
    />;

  if (buildStatus == "TEMPLATE_CONTACTED" || buildStatus == "LANDING_CONTACTED")
    return <PortalTemplateRequested
      flow={flow}
    />;

  return null;

}

export default Portal;